import styled from "styled-components";
import { ViewPageSectionBody } from "../../shared/view";

export const ContactViewModuleSection = styled(ViewPageSectionBody)`
	margin: ${({ theme }) => theme.spacing(5)} 0;
	display: grid;
	grid-template-columns: 1fr;

	${({ theme }) => theme.breakpoints.tablet} {
		grid-template-columns: 1fr 1fr;
	}

	${({ theme }) => theme.breakpoints.desktop} {
		grid-template-columns: 1fr 1fr 1fr;
	}

	gap: ${({ theme }) => theme.spacing(5)};
`;
